import { assignSafe } from '@summit/core';
import { TruckColumns } from '../shared/truck-columns.enum';
import { FinancialSalaryDistribution } from './financial-salary-distribution.enum';

export class FinanceParameter {
  salariesAboveTheLine: boolean;
  salaryDistribution: FinancialSalaryDistribution;
  reportsTruckSort: TruckColumns;

  constructor(jsonData?: Partial<FinanceParameter>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
    if (!this.salariesAboveTheLine) {
      this.salariesAboveTheLine = false;
    }
    if (!this.salaryDistribution) {
      this.salaryDistribution = FinancialSalaryDistribution.ByMile;
    }
    if (!this.reportsTruckSort) {
      this.reportsTruckSort = TruckColumns.TruckName;
    }
  }
}
